import styled from '@emotion/styled';
import styleService from '@nykaa/deals-utils/styles';
const { getPaddingStyles, getBKGStyles, getBorderStyles, getIndividualBorderRadius, getFontStyles, getMarginStyles, setVisibility, } = styleService.utils;
export const Wrapper = styled.div `
  max-width: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  background-color: ${({ appBkgColor }) => appBkgColor};
  ${({ setEmptyWidget }) => setVisibility(!setEmptyWidget)};    
`;
export const CardWrapper = styled.div `
  ${({ padding }) => getPaddingStyles(padding)};
  ${({ background }) => getBKGStyles(background)};
  ${({ individualCornerRadius }) => getIndividualBorderRadius(individualCornerRadius)};
  ${({ border }) => getBorderStyles(border)};
  ${({ outerPadding }) => getMarginStyles(outerPadding)};
  display: flex;
  width: fill-available;
  flex-direction: column;
  align-self: center;
  margin-left: 20px;
  margin-right: 20px;
`;
export const Title = styled.div `
  ${({ padding }) => getPaddingStyles(padding)};
  ${({ text }) => getFontStyles(text)};
  ${({ visible }) => setVisibility(visible)};
`;
export const Description = styled.div `
  ${({ padding }) => getPaddingStyles(padding)};
  ${({ text }) => getFontStyles(text)};
  ${({ visible }) => setVisibility(visible)};
`;
export const Separator = styled.div `
  position: relative;
  border-radius: ${({ endpoints, separatorHeight }) => (endpoints === 'round' ? separatorHeight === null || separatorHeight === void 0 ? void 0 : separatorHeight.web : 0)};
  height: ${({ separatorHeight }) => separatorHeight === null || separatorHeight === void 0 ? void 0 : separatorHeight.web};
  ${({ margin }) => getMarginStyles(margin)};
  ${({ backgroundColor }) => getBKGStyles(backgroundColor)};
  ${({ visible }) => setVisibility(visible)};
  :last-child {
    display: none !important;
  }

`;
